// El panel del profesor (18 oct 2026): sus clases, sus alumnos y la ficha de cada uno.
//
// El recorte a SUS clases lo hace el servidor (`backend/app/modules/analytics/profesor.py`):
// un alumno de otra clase no llega a esta pantalla ni dentro de una respuesta. Lleva el correo
// del alumno y sus dudas al mentor con la respuesta; el correo de su tutor, no.
import { api } from "./client";

// `como` es «Ver como» (18 oct 2026): solo el admin, y recibe lo mismo que ese profesor.
const conComo = (params, como) => ({ params: { ...params, como: como || undefined } });
export const getMisClases = (como = "") =>
  api.get("/profesor/clases", conComo({}, como)).then((r) => r.data?.clases || []);
export const getMisAlumnos = (clase = "", como = "") =>
  api.get("/profesor/alumnos", conComo({ clase: clase || undefined }, como)).then((r) => r.data);
export const getFichaDeMiAlumno = (id, como = "") =>
  api.get(`/profesor/alumnos/${encodeURIComponent(id)}`, conComo({}, como)).then((r) => r.data);
// Por leccion, que preguntas fallo a la primera mas gente de sus clases. Solo cuentas.
export const getPreguntasDeMisClases = (clase = "", como = "") =>
  api.get("/profesor/preguntas", conComo({ clase: clase || undefined }, como)).then((r) => r.data);

// LAS TAREAS DE SU CLASE (18 oct 2026, R2): el servidor da 404 si la clase no es suya, y solo
// deja mandar lecciones publicadas. `profeLeccionesDelCurso` es de donde se eligen.
export const profeLeccionesDelCurso = (cursoId) =>
  api.get(`/communities/cursos/${encodeURIComponent(cursoId)}/lecciones`).then((r) => r.data?.lecciones || []);
export const profeTareas = (claseId) =>
  api.get(`/communities/${encodeURIComponent(claseId)}/tareas`).then((r) => r.data?.tareas || []);
export const profeMandaTarea = (claseId, tarea) =>
  api.post(`/communities/${encodeURIComponent(claseId)}/tareas`, tarea).then((r) => r.data);
export const profeQuitaTarea = (claseId, tareaId) =>
  api.delete(`/communities/${encodeURIComponent(claseId)}/tareas/${encodeURIComponent(tareaId)}`).then((r) => r.data);

// LOS AVISOS DE SU CLASE (18 oct 2026, R3): dentro de la plataforma, sin correo, firmados
// «Tu profesor». `misAvisos` es la otra punta: los que le llegan al alumno en «Mi panel».
export const profeAvisos = (claseId) =>
  api.get(`/communities/${encodeURIComponent(claseId)}/avisos`).then((r) => r.data?.avisos || []);
export const profeMandaAviso = (claseId, aviso) =>
  api.post(`/communities/${encodeURIComponent(claseId)}/avisos`, aviso).then((r) => r.data);
export const profeQuitaAviso = (claseId, avisoId) =>
  api.delete(`/communities/${encodeURIComponent(claseId)}/avisos/${encodeURIComponent(avisoId)}`).then((r) => r.data);
export const misAvisos = () => api.get("/communities/mis-avisos").then((r) => r.data?.avisos || []);

// La misma contrasena nueva que da el admin, pedida por el profesor de ESA clase. Vuelve en
// claro y una sola vez; el servidor da 404 si la clase no es suya o el alumno no es de ella.
export const profeRegeneraClave = async (claseId, userId) => {
  const { data } = await api.post(
    `/communities/${encodeURIComponent(claseId)}/members/${encodeURIComponent(userId)}/clave`);
  return data;
};
